import type { Color } from '@anov/3d-core'

export { GridMaterial } from './PristineGridMaterial'

export interface GridMaterialInterface {

  /**
   * 主网格线宽
   */
  majorLineWidth: number

  /**
   * 次网格线宽
   */
  minorLineWidth: number

  /**
   * 坐标轴线宽
   */
  axisLineWidth: number

  /**
   * 主网格间隔
   */
  majorGridDiv: number

  /**
   * 次网格间隔
   */
  gridDiv: number

  /**
   * 主网格颜色
   */
  majorLineColor: Color

  /**
   * 次网格颜色
   */
  minorLineColor: Color

  /**
   * x轴颜色
   */
  xAxisColor: Color

  /**
   * y轴颜色
   */
  zAxisColor: Color

  /**
   * 基础颜色
   */
  baseColor: Color
}